import React from 'react';
import {Link, useNavigate} from 'react-router-dom';
import swal from 'sweetalert';

import ProductTypeAddModal from '../../../component/siteManagementModals/productTypes/ProductTypeAddModal';

import {getCookie} from '../../../inc/cookies';
import config from '../../../inc/config';
import {isoToDateTime} from '../../../inc/helper';

class ProductTypeModule extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      isOpenProductTypeAddModal: false,

      productTypes: []
    };

    this.onCompleted = this.onCompleted.bind(this);
  }

  componentDidMount() {
    this.getProductTypes();
    window.scrollTo(0, 0);
  }

  componentWillUnmount() {
  }

  getProductTypes() {
    let sessionHash = getCookie('sessionHash');

    this.setState({isLoading: true});

    const requestOptions = {
      method: 'GET',
      headers: {'Authorization': 'Bearer ' + sessionHash}
    };

    fetch(config.restApi + 'productTypes', requestOptions)
    .then(response => response.json())
    .then(responseData => {
      switch(responseData.status) {
        case 200: {
          this.setState({isLoading: false, productTypes: responseData.productTypes});
        }
        break;
        default: {
          this.setState({isLoading: false});

          swal({
            dangerMode: true,
            icon: 'warning',
            title: 'Hay Aksi',
            text: responseData.message,
            buttons: 'Tamam'
          }).then(() => this.props.navigate('/home'));
        }
        break;
      }
    }, () => swal({dangerMode: true, icon: 'error', title: 'Bağlantı Hatası', text: 'Lütfen internet bağlantınızı kontrol ediniz.', buttons: 'Tamam'}));
  }

  onCompleted() {
    this.getProductTypes();
    this.setState({isOpenProductTypeAddModal: false});
  }
  
  render() {
    return this.state.isLoading ?
      <div className="ibox-content sk-loading position-static">
        <div className="sk-spinner sk-spinner-fading-circle">
          <div className="sk-circle1 sk-circle"></div>
          <div className="sk-circle2 sk-circle"></div>
          <div className="sk-circle3 sk-circle"></div>
          <div className="sk-circle4 sk-circle"></div>
          <div className="sk-circle5 sk-circle"></div>
          <div className="sk-circle6 sk-circle"></div>
          <div className="sk-circle7 sk-circle"></div>
          <div className="sk-circle8 sk-circle"></div>
          <div className="sk-circle9 sk-circle"></div>
          <div className="sk-circle10 sk-circle"></div>
          <div className="sk-circle11 sk-circle"></div>
          <div className="sk-circle12 sk-circle"></div>
        </div>
      </div>
      :
      <>
        <div className="row">
          <div className="col">
            <div className="ibox">
              <div className="ibox-title text-darkblue d-flex justify-content-between pr-2 pl-0">
                <div className="col-7 col-xl-8"><h5>Ürün Tipi Listesi</h5></div>
                <button className="btn btn-orange mb-2" onClick={() => this.setState({isOpenProductTypeAddModal: true})} title="Ekle"><i className="fa fa-plus"></i> Ürün Tipi Ekle</button>
              </div>
              <div className="table-responsive overflow-x-auto">
                <table className="table table-striped table-bordered">
                  <thead>
                    <tr className="text-center text-darkblue">
                      <th>Ürün Tipi</th>
                      <th>Açıklama</th>
                      <th>Düzenlenme Tarihi</th>
                      <th>Durum</th>
                      <th>İşlem</th>
                    </tr>
                  </thead>
                  <tbody className="text-center">
                    {this.state.productTypes.map((productTypeInfo) =>
                      <tr key={productTypeInfo.id}>
                        <td className="align-middle">{productTypeInfo.name}</td>
                        <td className="align-middle">{productTypeInfo.description}</td>
                        <td className="align-middle">{isoToDateTime(productTypeInfo.modifiedDate)}</td>
                        <td className="align-middle">{productTypeInfo.active == 1 ? 'Açık' : 'Kapalı'}</td>
                        <td className="align-middle">
                          <Link className="btn btn-orange text-center" to={"/productTypeEdit?id=" + productTypeInfo.id}><i className="fa fa-pencil text-white action-icon"></i></Link>
                        </td>
                      </tr>
                    )}
                    {this.state.productTypes.length == 0 ?
                      <tr>
                        <td className="align-middle p-3" colSpan="5">Ürün Tipi Bulunamadı !</td>
                      </tr>
                    : null}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <ProductTypeAddModal isOpen={this.state.isOpenProductTypeAddModal} modalTitle="Ürün Tipi Ekle" modalDescription="Ürün tipi eklemek için aşağıdaki alanları doldurunuz !" onCompleted={this.onCompleted} onRequestClose={() => this.setState({isOpenProductTypeAddModal: false})} />
      </>
  }
}

export default function ProductTypes() {
  return (
    <ProductTypeModule navigate={useNavigate()} />
  )
}